import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcErrorFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.413 16.59c-1.095 1.833.226 4.16 2.36 4.16h14.453c2.135 0 3.456-2.327 2.36-4.16l-7.225-12.1c-1.067-1.786-3.655-1.786-4.722 0zm9.102.953a.87.87 0 0 0 .635.265q.372 0 .636-.265a.87.87 0 0 0 .264-.635.87.87 0 0 0-.264-.636.87.87 0 0 0-.636-.264.87.87 0 0 0-.636.264.87.87 0 0 0-.264.636q0 .372.264.635m.056-2.918q.24.24.578.24a.8.8 0 0 0 .58-.24q.24-.24.24-.579l.2-5.227a.8.8 0 0 0-.24-.578c-.16-.16-.553-.241-.778-.241-.226 0-.619.08-.78.24a.79.79 0 0 0-.24.58l.2 5.226q0 .338.24.579",
    clipRule: "evenodd"
  }));
}
var IcErrorFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcErrorFill));

export { IcErrorFill as I };
